import { ChakraProvider } from "@chakra-ui/react";
import ReactDOM from "react-dom/client";
import { Client, Provider } from "urql";
import App from "~/App";
import { createClient } from "~/graphqlClient";
import * as Sentry from "@sentry/react";
import { ToastContainer } from "./graphqlClient/exchanges/commonErrorExchange";
import { createContext, useEffect, useState } from "react";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://9df8537af2184ecfb02f66dc6f9fe178@o1084598.ingest.sentry.io/4504948747730944",
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

export const GraphqlClientContext = createContext<{
  graphqlClient: Client;
  refreshGraphqlClient: () => void;
}>({
  graphqlClient: createClient(),
  refreshGraphqlClient: () => {},
});

const Root = () => {
  const [graphqlClient, setGraphqlClient] = useState<Client | undefined>(
    undefined
  );

  useEffect(() => {
    refreshGraphqlClient();
  }, []);

  const refreshGraphqlClient = () => {
    setGraphqlClient(createClient());
  };
  if (!graphqlClient) return null;
  return (
    <GraphqlClientContext.Provider
      value={{
        graphqlClient,
        refreshGraphqlClient,
      }}
    >
      <Provider value={graphqlClient}>
        <ChakraProvider>
          <App />
          <ToastContainer />
        </ChakraProvider>
      </Provider>
    </GraphqlClientContext.Provider>
  );
};

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <Root />
);
